import React, { useState, useMemo } from "react";
import { Play, ExternalLink } from "lucide-react";
import { PORTFOLIO_CATEGORIES, PORTFOLIO_ITEMS, PROFILE } from "@/lib/portfolioData";
import SectionHeader from "@/components/SectionHeader";
import Reveal from "@/components/Reveal";

export default function PortfolioGallery() {
  const [active, setActive] = useState("All");

  const items = useMemo(() => {
    if (active === "All") return PORTFOLIO_ITEMS;
    return PORTFOLIO_ITEMS.filter((i) => i.category === active);
  }, [active]);

  return (
    <section
      id="portfolio"
      className="relative py-24 md:py-36 px-6 md:px-10 bg-[#0d0d0d]"
      data-testid="portfolio-section"
    >
      <div className="max-w-[1400px] mx-auto">
        <SectionHeader
          number="06"
          tag="Selected Work"
          title={<>
            The <span className="text-gradient-gold">Gallery</span>
          </>}
          kicker="A curated selection across travel films, cinematic reels, brand content and photography."
        />

        {/* Filters */}
        <div className="flex flex-wrap gap-2 mb-10" data-testid="portfolio-filters">
          {PORTFOLIO_CATEGORIES.map((cat) => (
            <button
              key={cat}
              onClick={() => setActive(cat)}
              data-testid={`filter-${cat.replace(/\s+/g, "-").toLowerCase()}`}
              className={`px-4 py-2 rounded-full text-xs uppercase tracking-[0.22em] font-display transition-all duration-300 border ${
                active === cat
                  ? "bg-[#D4AF37] text-black border-[#D4AF37]"
                  : "text-white/70 border-white/10 hover:border-[#D4AF37]/40 hover:text-white"
              }`}
            >
              {cat}
            </button>
          ))}
        </div>

        {/* Masonry via CSS columns */}
        <div className="columns-1 sm:columns-2 lg:columns-3 gap-5">
          {items.map((item, i) => (
            <Reveal key={item.id} delay={(i % 3) * 80} className="mb-5 break-inside-avoid">
              <a
                href={item.link || PROFILE.instagramUrl}
                target="_blank"
                rel="noreferrer"
                className="pf-card group relative block overflow-hidden rounded-2xl border border-white/5 bg-[#161616]"
                data-testid={`portfolio-item-${item.id}`}
              >
                <div className="relative overflow-hidden">
                  <img
                    src={item.image}
                    alt={item.title}
                    className="w-full h-auto object-cover"
                    loading="lazy"
                  />
                </div>
              </a>
            </Reveal>
          ))}
        </div>

        <div className="mt-14 text-center">
          <a
            href={PROFILE.instagramUrl}
            target="_blank"
            rel="noreferrer"
            className="magnetic-btn"
            data-testid="portfolio-view-all"
          >
            View Full Portfolio on Instagram
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </section>
  );
}
